// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expand-wrapper {
  transition: max-height 0.4s ease-in-out;
  overflow: hidden;
  height: 100%;
}

.collapsed {
  max-height: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/accordion/accordion.component.scss"],"names":[],"mappings":"AAAA;EACE,uCAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".expand-wrapper {\n  transition: max-height 0.4s ease-in-out;\n  overflow: hidden;\n  height: 100%;\n}\n\n.collapsed {\n  max-height: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
